import { render, staticRenderFns } from "./FCDashboard.vue?vue&type=template&id=c560e24a&scoped=true&"
import script from "./FCDashboard.vue?vue&type=script&lang=js&"
export * from "./FCDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FCDashboard.vue?vue&type=style&index=0&id=c560e24a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560e24a",
  null
  
)

export default component.exports